"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class NumberUtils {
    static toHex(dec) {
        const radix = 16;
        return dec.toString(radix);
    }
    static isCeil(number) {
        return number % 1 === 0;
    }
}
exports.NumberUtils = NumberUtils;
